<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div class="banner-box">
      <van-swipe :autoplay="3000" :height="300" class="van-swipe-box" @change="onChange">
        <van-swipe-item v-for="(image, index) in banner" :key="index">
          <img :src="require('../../assets/'+appTheme+'/banner1.png')" />
        </van-swipe-item>
        <template #indicator>
          <!--        <div class="custom-indicator swipeIndexBox">{{ swipeIndex + 1 }}/{{banner.length}}</div>-->
          <div class="custom-indicator swipeIndexBox"><div v-for="(item,i) in banner" :class="[i==swipeIndex?'activeBanner':'']" :key="i"></div> </div>
        </template>
      </van-swipe>
    </div>
    <div class="shop-des-box">
      <div class="wrapper-goods-detail justify-align">
        <div class="lf-box left-justifying">
          <div class="goods-business-logo">
            <img class="cover-img" :src="shopInfo.full_logo" alt="" />
          </div>
          <div class="goods-business-content">
            <h2>{{shopInfo.name}}</h2>
            <div class="left-justifying box">
              <p>粉丝数：{{shopInfo.follow_count}}</p>
            </div>
          </div>
        </div>
        <div class="left-justifying">
          <div class="btn-orange" @click="shareClick">分享</div>
          <div v-if="shopInfo.is_follow==0" @click="clickCollect(1)" class="btn-orange follow-btn">关注</div>
          <div v-else @click="clickCollect(2)" class="btn-orange follow-btn" style="color: #999999;border-color: #999;">已关注</div>
        </div>
      </div>
      <div class="shop-score-box justify-align">
        <div class="score-item left-justifying"><span></span>宝贝描述 4.8 平</div>
        <div class="score-item content-center"><span></span>卖家服务 4.8 平</div>
        <div class="score-item" style="text-align: right"><span></span>物流服务 4.8 平</div>
      </div>
      <div class="goods-detail">
        <div class="goods-detail-row-title">商家全球网点</div>
        <div class="goods-detail-row-body">
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/yamaxun1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/ebay1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/red1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/jd1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/tianmao1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/taobao1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/pin1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/weixin1.png')" alt=""></div>
          </div>
        </div>
      </div>
      <div class="goods-detail" style="padding-top: 0;padding-bottom: 2.66667vw;margin-bottom: 2.66667vw;">
        <div class="goods-detail-row-title" style="padding-top: 0.66667vw;">商家全球直播号</div>
        <div class="goods-detail-row-body">
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/bilibili1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/douyin1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/kuaishou1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/taobaozhibo1.png')" alt=""></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/pin1.png')" alt="" /></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/red1.png')" alt="" /></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/fb1.png')" alt="" /></div>
          </div>
          <div class="shop-item">
            <div class="img-icon"><img :src="require('../../assets/'+appTheme+'/youtube1.png')" alt=""></div>
          </div>
        </div>
      </div>
    </div>

    <div class="shop-goods-box">
      <van-sticky>
        <div class="nav-box justify-align">
          <div class="item-nav" @click="clickNav(item.id)" :class="[navIndex==index?'active':'']" v-for="(item,index) in navList" :key="index">{{item.name}}</div>
        </div>
      </van-sticky>

      <div class="nav-content-box">
        <div class="nav-content" v-if="navIndex==0">
          <van-list v-if="list.length" v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
            <div class="goods-list">
              <div class="goods-item left-justifying" style="align-items: self-start;" v-for="(item,index) in list" :key="index" @click="goDes(item.id)">
                <img :src="item.image" alt="">
                <div class="goods-content">
                  <div class="goods-content-title">{{item.name}}</div>
                  <div class="price">￥{{item.price}}</div>
                </div>
              </div>
            </div>
          </van-list>
          <div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
        </div>
        <div class="nav-content" v-if="navIndex==1">
          <div class="discount-box" v-if="couponList.length>0">
            <div class="discount-box-item" v-for="(item,index) in couponList" :key="index">
              <div class="discount-box-default">
                <img class="discount-item-bg" :src="require('../../assets/'+appTheme+'/discount_bg.png')" alt="" />
                <div class="discount-box-content justify-align">
                  <div class="discount-item">
                    <div class="discount-num">
                      {{item.discount | filterDiscount}} <span>折</span>
                    </div>
                  </div>
                  <div class="discount-item discount-item-center" @click="clickBtn(item,index)">
                    <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div> </div>
                    <!--                  <div class="goods-txt uni-ellipsis">店铺：{{item.shop.name}}</div>-->
                    <div class="des-goods uni-ellipsis">{{item.desc}}</div>
                    <div class="hint">最终解释权归该商家</div>
                  </div>
                  <div class="discount-item discount-item-three">
                    <div class="is_use_box left-justifying" @click="clickCoupon(item)">
                      <div class="ling-qu-btn">
                        领取
                      </div>
                    </div>
                    <!--                  <div class="date">-->
                    <!--                    有效期至-->
                    <!--                  </div>-->
                    <!--                  <span style="font-size: 2.4vw;">{{item.use_endtime}}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="text-align: center;" v-else>暂无数据~</div>
        </div>
        <div class="nav-content" v-if="navIndex==2">
          <div class="merchant-info">
            <div class="merchant-item left-justifying">
              <img :src="require('../../assets/'+appTheme+'/b_phone.png')" alt="" />
              商家电话：{{shopInfo.phone}}
            </div>
            <div class="merchant-item left-justifying" style="border: none;text-align: left;align-items: self-start;">
              <img :src="require('../../assets/'+appTheme+'/b_icon.png')" alt="" />
              商家地址：{{shopInfo.address}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div style="position: relative;z-index: 4;" class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <div class="" style="text-align: center">
            <img class="img-goods goodsImg" :src="shopInfo.full_logo" alt="" />
            <div>
              <div class="title">{{shopInfo.name}}</div>
              <div class="fans">粉丝：{{shopInfo.follow_count}}</div>
            </div>
          </div>

          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>


      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import { getShopDes,shopCollect,discountCouponList,getDiscountCoupon } from '@/api/goods'
import {getWechat} from "@/api/zhibo";
const jweixin = require('jweixin-module');
export default {
  name: "shopDes",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      banner:[{},{}],
      swipeIndex:0,
      navIndex: 0,
      navList: [{id:0,name: '商品列表'},{id:1,name: '本店礼劵'},{id:2,name: '商家介绍'}],
      goodsList: [],
      shopId:'',
      shopInfo:'',
      is_follow:2, // 1关注 2取消
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      list: [],
      couponList: [],
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
      painting:{
        width: '510px',
        height: '600px',
        background: '#ffffff',
        borderRadius: '10px'
      }
    }
  },
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  components: {
    VueCanvasPoster
  },
  created() {
    var id = this.$route.query.id
    this.shopId = id
    this.getInfo()
    this.finished = false

    this.getGoodList()
  },
  methods: {
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        // console.log('ios')
      } else {
        // console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      // console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          let weChat = res.data
          // console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            // console.log('ready',that.desShare)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: that.shopInfo.name,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.shopInfo.full_logo,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              jweixin.onMenuShareTimeline({ // 旧版本
                title: that.shopInfo.name,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.shopInfo.full_logo,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: that.shopInfo.name,
                desc:'',
                link: urlPath, // keyi
                imgUrl: that.shopInfo.full_logo,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: that.shopInfo.name, // 分享标题
                desc: '', // 分享描述
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: that.shopInfo.full_logo, // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    shareShowHide(){

      this.shareShow = false
    },
    shareClick(){ // 生成二维码
      var id = this.shopInfo.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/shopDes?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          console.log(this.qrcodeUrl)
          this.shareShow = true
          this.drawPoster()
        }
      });

    },
    drawPoster(){

      this.painting = {
        width: '509px',
        height: '795px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '493px',
              height: '776px',
              right: '9px',
              top: '9px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: this.shopInfo.full_logo, //,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '128px',
              height: '128px',
              mode: 'scaleToFill',
              top: '90px',
              left: '80px',
              shadow: '10px 10px 10px #f5f5f5',
            }
          },
          {
            type: 'text',
            text: this.shopInfo.name, // this.shopInfo.name,
            css: [
              {
                top: '90px',
                width: '200px',
                maxLines: 2,
                lineHeight: '35px',
                left: '240px',
                fontSize: '28px',
                textAlign: 'left',
                color:'#000000'
              }
            ]
          },
          {
            type: 'text',
            text: '粉丝：'+this.shopInfo.follow_count,
            css: [
              {
                top: '185px',
                width: '200px',
                maxLines: 2,
                lineHeight: '50px',
                left: '240px',
                fontSize: '24px',
                color:'#666666'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '370px',
              height: '360px',
                top: '280px',
              left: '70px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "650px",
              left: "175px",
              width: "360px",
              maxLines: 1,
              fontSize: "20px",
              color: '#E43A0D',
            }
          }
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    clickCoupon(item,index){ // 领取优惠券 多个值，用逗号隔开
      console.log('item',item)
      console.log('index',index)
      var arr = this.couponList
      if (item.number >=1){
        var id = item.id
        getDiscountCoupon(id).then(res => {
          if(res.code == 200)
          {
            console.log('res',res)
            this.$toast('领取成功')
            setTimeout(() => {
              //通知父组件关闭
              console.log('调列表数据')
              this.getCouponList()
            }, 1000);

          }
          else
          {
            this.$toast.setDefaultOptions({ duration: 2000 });
            this.$toast(res.message)
          }
        })
      } else {
        this.$toast('已经领完~')
      }
    },
    getCouponList(){  // 获取商家优惠券
      discountCouponList( this.shopId).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res)
          this.couponList = res.data
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    getInfo(){  // 获取商家数据
      getShopDes( this.shopId).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res)
          this.shopInfo = res.data
          this.getShareInfo()
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    clickCollect(e){ // 是否关注
      this.is_follow = e
      // console.log('是否收藏',e)
      var that = this
      shopCollect(this.shopId,{status: e}).then(res => {
        if(res.code == 200)
        {
          this.$toast(res.message)
          if (e==1){
            that.shopInfo.is_follow = 1 // 设置已收藏 // 1关注 2取消
          } else {
            that.shopInfo.is_follow = 0
          }
          this.getInfo()
          // that.goodInfo.is_collect = e ==1? 1: 2
          // setTimeout(function()  {
          //   that.getGoodInfo()//娃娃消失
          // }, 1000);
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    async getGoodList () {
      var that = this
      var data ={
        shop_id: this.shopId,
        page: 1
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        this.loading = true // 防止多次触发load事件
        // console.log('res',res)
        this.list = res.data.data
        // console.log(this.list)
        // 加载状态结束
        this.loading = false;
        if (res.data.data.length == res.data.total){ // 数据全部加载完
          this.finished = true; // 数据全部加载完
          console.log('不加载')
          if(res.data.data==0){
            this.finishedTxt = '暂无数据~'
          } else {
            this.finishedTxt = '没有更多了~'
          }
        }else {
          that.finished = false; // 不可以加载
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async moreList(){
      var that = this
      this.currentPage += 1;//页数+1

      var data ={
          shop_id: this.shopId,
        page: this.currentPage
      }
      const res = await this.$Http.getGoodsList(data)
      // 加载状态结束
      this.loading = false;
      if (res.code == 200){
        // console.log('res',res.data.data)
        let arr = this.list.concat(res.data.data);
        // console.log(arr.length)
        that.list = arr
        if (that.list.length == res.data.total) { // 数据全部加载完成
          this.finished = true;
          console.log('加载完毕')
        } else {
          this.finished = false;
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    goDes(id){
      this.$router.push({path:'/goodDetails',query: {id: id}})
    },
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    onChange(index) {
      this.swipeIndex = index
    },
    clickNav(id){
      // console.log(id)
      this.navIndex = id
      if (this.navIndex==1){
        console.log('zheli')
        this.getCouponList()
      } else if (this.navIndex==0){

        this.loading =  false // 加载状态
        this.finished = false // 是否加载
        this.page =  1
        this.currentPage =1
        this.immediate = false
        this.list= []
        this.getGoodList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.banner-box{
  position: relative;
  .van-swipe-box{
    width: 750px;height: 252px;
    .van-swipe-item{
      height: 252px;
      img{
        height: 252px; width: 750px;
      }
    }
  }
  .swipeIndexBox{
    position: absolute;left: 0;bottom: 20px;width: 100%;text-align: center;
    div{
      width: 36px;
      height: 4px;
      background: #FFFFFF;
      opacity: 0.5;
      border-radius: 2px;display: inline-block;margin-right: 10px;
    }
    .activeBanner{
      opacity: 1;
    }
  }
  .goods-detail-img-icon{
    position: absolute;
    margin: auto;width: 100%;
    left: 0;top: 309px;
    .vr-icon{
      width: 136px;height: auto;margin-left: 83px;display: inline-block;
    }
  }
}
.wrapper-goods-detail{
  padding: 20px;background: #fff;
  .goods-business-logo {
    margin-top: -70px;position: relative;box-shadow: 0px 0px 15px 15px rgba(0,0,0,0.2);border-radius: 10px;
    img{
      width: 138px;
      height: 138px;
      border-radius: 10px;
    }
  }
  .goods-business-content{
    margin-left: 35px;
  }
  h2{
    font-size: 32px;text-align: left;margin-bottom: 0;margin-top: 0;font-weight: bold;color: #000000;
  }

  .box{
    color: #B2B2B2;font-size: 24px;
    p{
      margin: 0 0;text-align: left;color: #000000;font-size: 24px;
    }
    .goods-business-level{
      font-size: 24px;text-align: left; margin-left: 10px;
    }
  }

  .btn-orange{
    width: 106px;
    padding: 6px 0;
    background: #FFFFFF;
    border: 2px solid #8FC45F;
    border-radius: 23px;font-size: 25px;font-weight: 400;
    color: #8FC45F;text-align: center;
  }
  .follow-btn{
    border: 2px solid #F23926;color: #F23926;margin-left: 15px;
  }
}
.shop-score-box{
  background: #ffffff;padding: 10px 24px 0;font-size: 24px;color: #000000;
  .score-item{
    width: 33.3%;text-align: center;
    span{
      display: inline-block;width: 12px;
      height: 12px;
      background: #8FC45F;
      border-radius: 50%;margin-right: 10px;
    }
  }
}
.goods-detail{
  border-left: 0;
  border-right: 0;
  padding: 10px;background: #ffffff;
  .goods-detail-row-title {
    font-weight: 500;
    color: #A6A6A6;
    padding: 15px;
    text-align: left;
  }
  .goods-detail-row-body{
    margin: 0;
    .shop-item{
      display: inline-block;
      width: 12.5%;
      text-align: center;
      .img-icon{
        width: 75px;
        height: 75px;margin: 0 auto;
        img{
          width: 100%;display: block;height: auto;
        }
      }
    }
  }
}
.shop-goods-box{
  .nav-box{
    padding: 30px 75px;color: #282828;font-size: 26px;background: #FFFFFF;margin-bottom: 20px;
    .active{
      font-weight: bold;
      color: #F23926;font-size: 30px;
    }
  }
}
.nav-content-box{
  padding: 0 24px;
  .merchant-info{
    background: #ffffff;padding: 0 24px;font-weight: bold;
    color: #000000;font-size: 24px;
    .merchant-item{padding: 30px 0;border-bottom: 2px solid #D2D2D2;
      img{
        width: 30px;height: auto;display: inline-block;margin-right: 10px;
      }
    }
  }

}
.goods-list{
  .goods-item{
    background: #ffffff;padding: 20px;margin-bottom: 20px;border-radius: 25px;position: relative;
    img{
      width: 160px;
      height: 160px;
      border-radius: 10px;margin-right: 38px;
    }
    .goods-content{
      font-size: 28px;text-align: left;color: #000000;
      span{display: inline-block;font-size: 18px;font-weight: bold;background: #F23926;border-radius: 5px;
        color: #FFFFFF;padding: 5px 10px}
      .price{
        font-size: 32px;font-weight: bold;
        color: #F23926;
        position: absolute;left: 198px;bottom: 20px;
      }
      .goods-content-title{
        width: 100%; overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;font-size: 28px;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.discount-box{
  padding-bottom:50px;
  .discount-box-item{
    width: 100%;margin: 25px auto 0;
    .discount-box-default{
      position: relative;

    }
    .discount-item-bg{
      width: 100%;height: auto;display: block;
    }
    .discount-box-content{
      position: absolute;z-index: 2;
      left: 30px;
      top: 50px;
      .discount-num{
        font-weight: bold;font-size: 50px;width: 130px;text-align: center;margin-right: 40px;
        color: #FF953A;
        span{

          font-size: 22px;
        }
      }
      .title{
        .title-txt{
          font-size: 28px;
          font-weight: bold;
          color: #E9400B;width: 75%;
          overflow: hidden;
        }
        img{
          width: 12px;display: inline-block;height: auto;margin-left: 20px;
        }
      }
      .discount-item-center{
        padding: 0 20px;font-size: 22px;width: 270px;text-align: left;color: #9E9E9E;
        .goods-txt{
          display: inline-block;
          background: #FFF0E5;
          border-radius: 19px;font-weight: 400;
          color: #FB6666;font-size: 22px;padding: 5px 10px;margin: 20px auto;width:80%;
          overflow: hidden;
        }
        .des-goods{
          width: 90%;margin-bottom: 10px;font-size: 26px;margin-top: 20px;
          overflow: hidden;
        }
      }
      .discount-item-three{
        color: #FFFFFF;margin-left: 25px;
        .date{
          margin-top: 22px;margin-bottom: 5px;
        }
      }
      .is_use_box{
        font-size: 36px;color: #FFFFFF;
        .ling-qu-btn{
          font-size: 26px;text-align: center;
          height: 60px;
          background: #FFFFFF;
          border-radius: 30px;color: #282828;line-height: 60px;padding: 0 40px;
        }
      }
    }
  }
}
.imageWrapper{
  width: 520px;
  height:700px;
  background: #FFFFFF;
  border: 6px solid #FDD80D;
  border-radius: 20px;margin: 0 auto;position: absolute;z-index: 999;
  .title{
    font-size: 30px;display: inline-block;
    color: #282828;
    line-height: 34px;
  }
  #canvas{
    width: 370px;
    height: 370px;
  }
  .img-goods{
    width: 120px;
    height: 120px;
    border-radius: 50px;display: inline-block;margin-right: 20px;margin-top: 50px;margin-bottom: 20px;
  }
  .fans{
    margin-top: 20px;font-size: 26px;
  }
  .qr-code-img{
    width: 200px;
    height: 200px;display: block;margin: 50px auto;
  }
  .hint{
    font-size: 24px;color: #E43A0D;text-align: center;
  }
}
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 120px auto 30px;
  }
  .poster-url{
    width: 520px;
    height: 890px;display: block;margin: 0 auto;
  }
}
.van-overlay{
  z-index: 99;
}
</style>
